import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { UnitConversionService, UnitConversionType } from "@services/unitConversion.service";

@Pipe({ name: 'unitConversion' })
@Injectable()
export class UnitConversionPipe implements PipeTransform {
    constructor(private unitConversionService: UnitConversionService) { }

    transform(input: string, includeUnit?: boolean, conversionTypeString?: string, precision?: number): string {

        let conversionType = UnitConversionType.Speed;

        if (conversionTypeString) {
            conversionType = this.unitConversionService.getConversionType(conversionTypeString);
        }

        if (includeUnit) {
            return this.unitConversionService.convertUnitWithSuffix(input, conversionType, precision);
        }

        return this.unitConversionService.convertUnitWithFormatting(input, conversionType, precision);
    }
}
